import React from 'react';
import { setGlobal } from 'reactn';
import AppSignal from "@appsignal/javascript";

import AppNavigator from './pages/AppNavigator';

/** Initialize appsignal */
const appsignal = new AppSignal({ key: "0d45a42b-3c99-4d07-944e-43f892af7d78" });

/** Initialize global values */
setGlobal({
  user: null,
  currentEndTotal: 0,
  sideMenuVisible: false,
  zoom: 100,
  lastUrlWithoutUser: null,
  entity: null,
  pageElementCache: {},
  saveStatus: []
});

/** Define environment */
let environment = process.env.NODE_ENV == 'development';

const props = { appsignal, environment }

const App = () => {
  return (
    <AppNavigator {...props} />
  )
}

export default App;
